import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getText, trackGA } from 'misc/helpers';

class Goodbye extends Component {
    render = () => {
        return (
            <div className="main-content">
                <div className="complement-content">
                    <img className="complement-logo" src="assets/images/verify/ico_dm_v.svg" alt="" />
                    <React.Fragment>
                        <h1>{getText('_6_5_titel_welcomeback', 'Välkommen åter!')}</h1>
                        <p>
                            {getText(
                                '_6_5_text_welcomeback',
                                'Vi tycker det är mycket tråkigt att du har valt att lämna oss, men hoppas att vi snart ses igen. \n\nEtt bekräftelse mail om att du har valt att avsluta din tjänst kommer att skickas till din angivna e-postadress.\n\nVi önskar dig en fortsatt fin dag!'
                            )}
                        </p>
                    </React.Fragment>
                </div>
                <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
            </div>
        );
    };

    componentDidMount() {
        trackGA('6.5 Välkommen åter');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(Goodbye);



// WEBPACK FOOTER //
// ./src/components/views/Goodbye.js